import { render, staticRenderFns } from "./AchievementsCard.vue?vue&type=template&id=45c1ed36&"
import script from "./AchievementsCard.vue?vue&type=script&lang=js&"
export * from "./AchievementsCard.vue?vue&type=script&lang=js&"
import style0 from "./AchievementsCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports